import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion"

const HomeSection3 = () => {
  return (
    <div className="sm:grid sm:grid-cols-8   bg-white  w-full overflow-x-auto sm:overflow-auto">
      <div className="col-start-2 col-end-8 h-full w-full  flex  grid sm:grid-cols-2 py-20 sm:py-32 gap-5">
        <div className="w-full sm:w-auto aspect-square sm:aspect-auto  sm:h-auto group hover:scale-105 transition-all duration-500">

          <Link to={'/house'} className="relative h-full cursor-pointer block">
            <img src="/images/projects/house/1.jpg" className="w-full h-full object-cover" />
            <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
            <div className="absolute w-full h-full  top-0 left-0 transition-all duration-500 ">
              <div className='h-full w-full  flex flex-col items-center justify-between px-5'>
                <div className='flex-none relative w-1/2 mt-14 group-hover:scale-105 transition-all duration-500'>
                  <img src="/images/projects/house/logo-house-white-u.svg" className='w-full' />
                  <img src='/images/projects/house/logo-house-white-text.svg' className='w-full absolute top-0' />
                </div>

                <div className='flex flex-col items-center justify-between pb-10'>
                  <div className='text-white text-18 md:text-28 font-medium font-adobe  tracking-[0.28rem] leading-tight pb-6 md:pb-4'>
                    Şehrin tam yerinde, <br /> yaşamın merkezinde.
                  </div>

                  <div className="inline-flex space-x-2 py-2 px-6 rounded-3xl bg-white group-hover:bg-ulusOrange group-hover:scale-105 transition-all duration-500 ">
                    <h6 className="text-21 text-black font-bold">KEŞFET</h6>
                    <img src="/images/icons/kesfet-right-black.svg" className="w-8" />
                  </div>
                </div>
              </div>


            </div>


          </Link>

          <div className="h-6 w-full hidden sm:block "></div>
        </div>

        <div className="w-full sm:w-auto aspect-square sm:aspect-auto  sm:h-auto group hover:scale-105 transition-all duration-500">
          <div className="h-6 w-full  hidden sm:block"></div>
          <Link to={'/biten-projeler'} className="relative h-full cursor-pointer block">
            <img src="/images/istek-koleji.jpg" className="w-full h-full object-cover" />
            <div className='absolute bottom-0 left-0 h-1/3 w-full bg-gradient-to-t from-black to-transparent '></div>
            <div className="absolute w-full h-full top-0 left-0 transition-all duration-500">
              <div className='h-full w-full flex flex-col items-center justify-end px-5'>
      

                <div className='flex flex-col items-center justify-between pb-10'>
                  <div className='text-white text-18 md:text-28 font-medium font-adobe text-center tracking-[0.28rem] leading-tight pb-6 md:pb-4'>
                    Tamamlanan <br/> projelerimiz
                  </div>

                  <div className="inline-flex space-x-2 py-2 px-6 rounded-3xl bg-white group-hover:bg-ulusOrange group-hover:scale-105 transition-all duration-500 ">
                    <h6 className="text-21 text-black font-bold">KEŞFET</h6>
                    <img src="/images/icons/kesfet-right-black.svg" className="w-8" />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

      </div>

    </div>)
}

export default HomeSection3